module.exports = __webpack_public_path__ + "static/img/main.14b6afd2.png";